<script>
// Cajas POS
import { authComputed } from '@state/helpers'
import { euroCouponsThirdpartyMethods } from '@state/helpers'
import ThirdpartyCouponModal from '@components/euro_pos/ThirdpartyCouponModal.vue'

export default {
  name: 'ThirdpartyCardsGroup',
  components: {
    ThirdpartyCouponModal,
  },
  data() {
    return {
      loadingEuroCouponsThirdpartyOptions: false,
      thirdpartyOptions: null,
      showThirdpartyCouponModal: false,
    }
  },
  mounted() {
    this.populateEuroCouponsThirdpartyOptions()
  },

  watch: {},
  computed: {},

  methods: {
    ...euroCouponsThirdpartyMethods,
    populateEuroCouponsThirdpartyOptions(searchQuery) {
      let context = this
      context.loadingEuroCouponsThirdpartyOptions = true
      let reqParams = context.$select_params(searchQuery)
      const promise = context.fetchEuroCouponsCashRegisterThirdpartyOptions(reqParams)
      return promise
        .then((data) => {
          let listOptions = []
          while (data.results.length) {
            if (data.results.length >= 3) {
              listOptions.push(data.results.splice(0, 3))
            } else {
              listOptions.push(data.results.splice(0))
            }
          }
          context.thirdpartyOptions = listOptions
          console.log(context.thirdpartyOptions)
          context.loadingEuroCouponsThirdpartyOptions = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loadingEuroCouponsThirdpartyOptions = false
        })
    },
  },
}
</script>

<template>
  <div>
    <div>
      <b-card-group v-for="(group, idx) in thirdpartyOptions" :key="idx" deck>
        <b-card v-for="( thirdparty, index) in group" :key="index"
          role="button"
          header-bg-variant="transparent"
          style="max-width:236px"
          class="shadow mb-3 zoom"
          footer-class="bg-white text-center font-weight-bold p-1 card-coupon-footer"
          body-class="p-0 my-auto"
          no-body
          @click="()=>{showThirdpartyCouponModal=true; toShow=thirdparty}"
        >
          <b-card-body class="p-1" style="height: 180px; max-height: 200px">
            <div
              style="height: 180px; max-height: 180px"
              class="d-flex align-items-center justify-content-center"
            >
              <b-img
                fluid
                class="h-100"
                :src="thirdparty.logo"
                :alt="`logo ${thirdparty.name}`"
              ></b-img>
            </div>
          </b-card-body>
          <template #footer>
            {{thirdparty.name}}
          </template>
        </b-card>

      </b-card-group>
    </div>

    <ThirdpartyCouponModal
      v-if="showThirdpartyCouponModal"
      :instanceJson="toShow || {}"
      :oncomplete="
        () => {
          showThirdpartyCouponModal = false;
          toShow = {};
        }
      "
      :oncancel="
        () => {
          showThirdpartyCouponModal = false;
          toShow = {}
        }
      "
    >
    </ThirdpartyCouponModal>
  </div>
</template>
<style>
.custom-active-nav {
  border-left: solid 6px rgb(0, 54, 155);
}

.card-coupon-footer {
  min-height: 60px;
  max-height: 60px;
  font-family: "Roboto Condensed",sans-serif;
  font-size: 16px;
  font-weight: normal !important;
}

.cursor-pointer {
  cursor: pointer;
}

.zoom {
  transition: transform .2s;

}
.zoom:hover {
  transition: transform .2s;
  transform: scale(1.03); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}


</style>
